applications.service('MainContentService', function(DetermineAwardService, SliderService)
{
    this.activeDiv = "applicationOverview";
    this.setActiveDiv = function(div)
    {
        this.activeDiv = div;
        DetermineAwardService.setAwardComplete('active');
        SliderService.sliders = [];
        //SliderService.setSliderOverOpen(false);
    }
    this.getActiveDiv = function()
    {
        return this.activeDiv;
    }
    return this;

});